import { AdditionalCoverageInsuranceTypes } from 'features/policiesDashboard/utils/getAdditionalCoverage/getAdditionalCoverage';
import api from 'shared/api';

export const getAdditionalCoverageSuggestions = async () => {
  const response = await api.network.get<
    Array<{ type: AdditionalCoverageInsuranceTypes }>
  >('/cross-sell');
  return response.data;
};
